/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_BadgeInputs */

const et_faq_badge = /** @type {(inputs: Faq_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KKK`)
};

const en_faq_badge = /** @type {(inputs: Faq_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ`)
};

/**
* | output |
* | --- |
* | "FAQ" |
*
* @param {Faq_BadgeInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_badge = /** @type {((inputs?: Faq_BadgeInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_BadgeInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_badge(inputs)
	return en_faq_badge(inputs)
});